import { render, staticRenderFns } from "./resetpassword.vue?vue&type=template&id=0b2322b2&"
import script from "./resetpassword.vue?vue&type=script&lang=ts&"
export * from "./resetpassword.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "resetpassword.vue"
export default component.exports